import { Controller } from "@hotwired/stimulus";

export default class extends Controller {
    static values = {
        msgid: String,
    };

    connect() {
        this.dismissed = false;
    }

    dismiss(event) {
        event.preventDefault();
        if (this.dismissed) return;
        this.dismissed = true;

        this.sendDismissRequest();
        this.hideBanner();
    }

    sendDismissRequest() {
        const msgId = this.msgidValue;
        if (!msgId) return;

        fetch(`/ajax/banner_messages/dismiss/${encodeURIComponent(msgId)}`, {
            method: "GET",
            credentials: "same-origin",
            headers: {
                "X-Requested-With": "XMLHttpRequest",
            },
        }).catch(() => {
            // Ignore errors so the banner still disappears for the user.
        });
    }

    hideBanner() {
        this.element.classList.remove("in");

        const remove = () => {
            this.element.remove();
        };

        this.element.addEventListener("transitionend", remove, { once: true });

        window.requestAnimationFrame(() => {
            this.element.classList.remove("show");
        });

        // Fallback in case transitionend never fires (older browsers).
        window.setTimeout(() => {
            if (this.element.isConnected) remove();
        }, 300);
    }
}
